import { useElapsedTime } from '@/hooks/useElapsedTime';
import { formatElapsedTime } from '@/utils/dateFormat';

interface LiveStreamTimerProps {
  startTime: string | null | undefined;
  isRunning: boolean;
  /**
   * Overrides the default styling, which assumes a light background. Dark
   * surfaces (e.g. the Team Live tile strap) must pass their own.
   */
  className?: string;
}

export function LiveStreamTimer({
  startTime,
  isRunning,
  className,
}: LiveStreamTimerProps) {
  const elapsedMs = useElapsedTime(startTime, isRunning);

  if (!isRunning || elapsedMs <= 0) {
    return null;
  }

  return (
    <span
      className={
        className ?? 'text-sm text-green-700 font-medium whitespace-nowrap'
      }
    >
      {formatElapsedTime(elapsedMs)}
    </span>
  );
}
